import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table,
  Form,
  InputGroup,
} from "react-bootstrap";
import Datetime from "react-datetime";
import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  updateSubscription_old_data,
  updateSubscription,
  GetAllSubscriptionPackageItem,
  GetSubscriptionCategory,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import axios from "axios";

class editsubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      titleError: null,
      description: "",
      descriptionError: null,
      category: "",
      categoryError: null,
      price: "",
      priceError: null,
      subscription_period: "",
      subscription_periodError: null,
      remind_before: "",
      remind_beforeError: null,
      deliver_before: "",
      deliver_beforeError: null,
      status: "1",
      statusError: null,
      quantity: "",
      quantityError: null,
      discount: "",
      discountError: null,
      packageImageError: null,
      eligibility: "1",
      eligibilityError: null,
      isdaterangepickerOpen: false,
      _notificationSystem: null,
      cardHidden: true,
      package_image: [],
      packageitemdetails: [],
      packageitem: null,
      packageitemoptiondetails: [],
      package_image_data: [],
      package_new_data: [],
      // package_item : [],
      subscription_category_list: [],
      primaryimage: "",
      localimagedata: [],
      eligibility_web: false,
      eligibility_app: false,
      charge_type: "",
      charge_typeError: "",
      charge_value: "",
      charge_valueError: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.subEligibility = this.subEligibility.bind(this);
    this.subEligibility2 = this.subEligibility2.bind(this);
  }
  subEligibility = (e, number) => {
    var checked = e.target.checked;
    this.setState({ eligibility_web: checked });
  };
  subEligibility2 = (e, number) => {
    var checked = e.target.checked;
    this.setState({ eligibility_app: checked });
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Subscription</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/subscription");
    }, 3000);
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  upload() {
    document.getElementById("selectImage").click();
  }
  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var id = JSON.parse(localStorage.getItem("subscriptionID"));

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    GetSubscriptionCategory(obj).then((res) => {
      // console.log(res,'sub_cate_res');
      this.setState({ subscription_category_list: res.data.data });
    });

    let compelte_hc = 1;
    let hc_pg_no = 1;
    while (compelte_hc == 1) {
      await GetAllSubscriptionPackageItem(hc_pg_no, obj).then((res) => {
        console.log(res.data.data, "package item");
        const data = res.data.data.data;
        if (data.length == 0) {
          compelte_hc = 0;
        } else {
          var array1 = this.state.packageitemdetails;
          var array2 = array1.concat(data);

          this.setState({
            packageitemdetails: array2,
          });
          let hcItems = [];
          this.state.packageitemdetails.map((x, i) => {
            hcItems.push({ value: x.id, label: x.title });
          });
          this.setState({
            packageitemoptiondetails: hcItems,
          });
        }
      });
      hc_pg_no++;
    }

    updateSubscription_old_data(id, obj).then((res) => {
      var data = res.data;
      var status_value = "";
      var eligibility_value = "";
      if (data.status == "1") {
        status_value = "1";
      } else {
        status_value = "2";
      }
      var eligibility_web = false;
      var eligibility_app = false;

      data.eligibility.split(",").map((eligi) => {
        if (eligi == 1) {
          eligibility_web = true;
        }
        if (eligi == 0) {
          eligibility_app = true;
        }
      });
      /*if(data.eligibility == "1")
        {
          eligibility_value = "1"
        }else
        {
          eligibility_value = "2"
        }*/
      var hc = [];
      var newdata = [];
      hc = data.packageItems;
      // console.log(hc,'hc ')
      if (hc == null) {
        this.setState({ packageitem: null });
      } else {
        // const splic = hc.split(",");
        // console.log(splic,'splic',hc)
        hc.map((h) => {
          this.state.packageitemdetails.map((fd) => {
            // console.log(fd);
            if (h.subscription_package_item_id == fd.id)
              newdata.push({ value: fd.id, label: fd.title });
          });
        });
      }
      this.setState({ packageitem: newdata });
      data.packageImages.map((m) => {
        if (m.is_primary_image == 1) {
          this.setState({ primaryimage: m.image_url });
        }
      });
      var idata = [];
      data.packageImages.map((m) => {
        console.log(m);
        idata.push(m.image_url);
      });

      console.log(data.packageImages, "package images ");
      this.setState({
        title: data.title,
        quantity: data.quantity,
        description: data.description,
        category: data.category,
        price: data.price,
        subscription_period: data.subscription_period,
        remind_before: data.remind_before,
        deliver_before: data.deliver_before,
        status: status_value,
        discount: data.discount,
        eligibility: eligibility_value,
        eligibility_app: eligibility_app,
        eligibility_web: eligibility_web,
        package_image_data: idata,
        localimagedata: data.packageImages,
        charge_type: data.charge_type,
        charge_value: data.charge_value,
      });
    });
  }
  onChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === "select" ? target.selected : target.value;
    console.log(value, "value");
    this.setState({
      [name]: value,
    });
  }

  async onSubmit() {
    let error = false;
    if (this.state.title.length == 0) {
      error = true;
      this.setState({
        titleError: <small className="text-danger">title is required..</small>,
      });
    } else {
      this.setState({ titleError: null });
    }

    if (this.state.category.length == 0) {
      error = true;
      this.setState({
        categoryError: (
          <small className="text-danger">Category is required..</small>
        ),
      });
    } else {
      this.setState({ categoryError: null });
    }

    if (this.state.price.length == 0) {
      error = true;
      this.setState({
        priceError: <small className="text-danger">price is required..</small>,
      });
    } else {
      this.setState({ priceError: null });
    }
    //   if(this.state.description.length == 0)
    // {error = true
    //    this.setState({
    //     descriptionError: (
    //         <small className="text-danger">
    //            Description is required..
    //         </small>
    //       )
    //     })
    //   }else{ this.setState({ descriptionError: null });}
    if (this.state.subscription_period.length == 0) {
      error = true;
      this.setState({
        subscription_periodError: (
          <small className="text-danger">
            subscription period is required..
          </small>
        ),
      });
    } else {
      this.setState({ subscription_periodError: null });
    }
    if (this.state.remind_before.length == 0) {
      error = true;
      this.setState({
        remind_beforeError: (
          <small className="text-danger">Remind Before is required..</small>
        ),
      });
    } else {
      this.setState({ remind_beforeError: null });
    }
    if (this.state.deliver_before.length == 0) {
      error = true;
      this.setState({
        deliver_beforeError: (
          <small className="text-danger">Deliver Before is required..</small>
        ),
      });
    } else {
      this.setState({ deliver_beforeError: null });
    }
    if (
      this.state.remind_before.length != 0 &&
      this.state.deliver_before.length != 0
    ) {
      if (
        parseInt(this.state.remind_before) <=
        parseInt(this.state.deliver_before)
      ) {
        error = true;
        this.setState({
          deliver_beforeError: (
            <small className="text-danger">
              Deliver days Before must be grater than remind days..
            </small>
          ),
        });
      } else {
        this.setState({ deliver_beforeError: null });
      }
    }
    if (this.state.quantity.length == 0) {
      error = true;
      this.setState({
        quantityError: (
          <small className="text-danger">Quantity is required..</small>
        ),
      });
    } else {
      this.setState({ quantityError: null });
    }
    if (this.state.discount.length == 0) {
      error = true;
      this.setState({
        discountError: (
          <small className="text-danger">discount is required..</small>
        ),
      });
    } else {
      this.setState({ discountError: null });
    }
    if (this.state.package_image_data.length == 0) {
      error = true;
      this.setState({
        packageImageError: (
          <small className="text-danger">Package image is required..</small>
        ),
      });
    } else {
      this.setState({ packageImageError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var id = JSON.parse(localStorage.getItem("subscriptionID"));

      var packageimages = this.state.package_image_data;

      let package_item = [];
      if (this.state.packageitem == null) {
        package_item = "";
      } else {
        this.state.packageitem.map((data) => {
          var array1 = package_item;
          var array2 = array1.concat(data.value);
          package_item = array2;
        });
      }
      var status_data = "";
      var eligibility_data = [];
      if (this.state.status == "1") {
        status_data = "1";
      } else if (this.state.status == "2") {
        status_data = "0";
      }
      /*
    if(this.state.eligibility == "1")
    {
      eligibility_data = "1"
    }else if(this.state.eligibility == "2")
    {
      eligibility_data = "0"
    } */
      if (this.state.eligibility_web === true) {
        eligibility_data.push(1);
      }
      if (this.state.eligibility_app === true) {
        eligibility_data.push(0);
      }
      updateSubscription(
        this.state.title,
        this.state.description,
        this.state.category,
        this.state.price,
        this.state.subscription_period,
        this.state.remind_before,
        this.state.deliver_before,
        status_data,
        this.state.discount,
        eligibility_data,
        packageimages,
        package_item,
        this.state.primaryimage,
        id,
        this.state.quantity,
        this.state.charge_type,
        this.state.charge_value,
        obj
      )
        .then((res) => {
          if (res.data.success === false) {
            this.handleClick("bl");
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  }
  async handleFileChange(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ package_image: data });

    var packageimages = "";
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (data.length != 0) {
      console.log(data, "package image");
      this.setState({ processing: true });

      const fdata = new FormData();

      data.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("image_file[]", file[i]);
          console.log(file[i], "in file");
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/image";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          console.log(res, "res for package image");
          packageimages = res.data.data.image_url;
          this.setState({ package_image_data: packageimages });
        });
    } else {
      let pdata = [];

      this.state.package_image_data.map((p) => {
        if (p.length != 0) {
          pdata.push(p);
        }
      });
      packageimages = pdata;
      this.setState({ package_image_data: packageimages });
    }
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  render() {
    console.log(this.state.package_image_data, "render");
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Title</ControlLabel>
                          <FormControl
                            name="title"
                            value={this.state.title}
                            onChange={(event) => {
                              this.setState({ title: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                    titleError: (
                                      <small className="text-danger">
                                        title is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ titleError: null });
                            }}
                            placeholder="Enter title"
                            type="text"
                          />
                          {this.state.titleError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Category</ControlLabel>
                          <select
                            onChange={this.onChange}
                            name="category"
                            className="form-control"
                            value={this.state.category}
                          >
                            <option value="">Select Category</option>
                            {this.state.subscription_category_list.map((s) => (
                              <option value={s.category_name}>
                                {s.category_name == "all"
                                  ? "Unisex"
                                  : s.category_name}
                              </option>
                            ))}
                          </select>
                          {this.state.categoryError}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel> Description</ControlLabel>
                          <textarea
                            name="description"
                            rows="5"
                            className="form-control"
                            value={this.state.description}
                            onChange={(event) => {
                              this.setState({
                                description: event.target.value,
                              });
                              // event.target.value === ""
                              //   ? this.setState({
                              //     descriptionError: (
                              //         <small className="text-danger">
                              //           Description is required.
                              //         </small>
                              //       )
                              //     })
                              //   : this.setState({ descriptionError: null });
                            }}
                            placeholder="Enter Description"
                            type="text"
                          ></textarea>
                          {this.state.descriptionError}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <ControlLabel>price</ControlLabel>
                              <FormControl
                                name="price"
                                onWheel={(e) => e.target.blur()}
                                value={this.state.price}
                                onChange={(event) => {
                                  this.setState({ price: event.target.value });
                                  event.target.value === ""
                                    ? this.setState({
                                        priceError: (
                                          <small className="text-danger">
                                            price is required.
                                          </small>
                                        ),
                                      })
                                    : this.setState({ priceError: null });
                                }}
                                placeholder="Enter price"
                                type="number"
                              />
                              {this.state.priceError}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <ControlLabel>
                                Subscription Period (in days)
                              </ControlLabel>
                              <FormControl
                                name="subscription_period "
                                onWheel={(e) => e.target.blur()}
                                value={this.state.subscription_period}
                                onChange={(event) => {
                                  this.setState({
                                    subscription_period: event.target.value,
                                  });
                                  event.target.value === ""
                                    ? this.setState({
                                        subscription_periodError: (
                                          <small className="text-danger">
                                            Subscription Period is required.
                                          </small>
                                        ),
                                      })
                                    : this.setState({
                                        subscription_periodError: null,
                                      });
                                }}
                                placeholder="Enter subscription period (in days)"
                                type="number"
                              />
                              {this.state.subscription_periodError}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <ControlLabel>
                                Remind Before (in days)
                              </ControlLabel>
                              <FormControl
                                name="remind_before"
                                onWheel={(e) => e.target.blur()}
                                value={this.state.remind_before}
                                onChange={(event) => {
                                  this.setState({
                                    remind_before: event.target.value,
                                  });
                                  event.target.value === ""
                                    ? this.setState({
                                        remind_beforeError: (
                                          <small className="text-danger">
                                            Remind Before is required.
                                          </small>
                                        ),
                                      })
                                    : this.setState({
                                        remind_beforeError: null,
                                      });
                                }}
                                placeholder="Enter remind before (in days)"
                                type="number"
                              />
                              {this.state.remind_beforeError}
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Status</ControlLabel>
                              <div className="order_source_data">
                                <Radio
                                  style={{ display: "inline-block" }}
                                  number="1"
                                  option="1"
                                  name="status"
                                  onChange={this.onChange}
                                  checked={this.state.status === "1"}
                                  label="Active"
                                />
                                &nbsp;
                                <Radio
                                  style={{ display: "inline-block" }}
                                  number="2"
                                  option="2"
                                  name="status"
                                  onChange={this.onChange}
                                  checked={this.state.status === "2"}
                                  label="InActive"
                                />
                              </div>
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Eligibility</ControlLabel>
                              <div className="order_source_data">
                                {/*
                        <Radio
                             style={{'display':'inline-block'}}
                             number="3"
                             option="1"
                             name="eligibility"
                             onChange={this.onChange}
                             checked={this.state.eligibility === "1"}
                             label="Web"
                           />&nbsp;
                           <Radio
                             style={{'display':'inline-block'}}
                             number="4"
                             option="2"
                             name="eligibility"
                             onChange={this.onChange}
                             checked={this.state.eligibility === "2"}
                             label="App"
                           /> */}
                                <Checkbox
                                  number="46"
                                  checked={this.state.eligibility_web}
                                  onChange={(e) => this.subEligibility(e, 0)}
                                  label="Web"
                                ></Checkbox>
                                <Checkbox
                                  number="47"
                                  checked={this.state.eligibility_app}
                                  onChange={(e) => this.subEligibility2(e, 1)}
                                  label="App"
                                ></Checkbox>
                              </div>
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>Quantity</ControlLabel>
                              <FormControl
                                name="quantity"
                                value={this.state.quantity}
                                onWheel={(e) => e.target.blur()}
                                onChange={(event) => {
                                  this.setState({
                                    quantity: event.target.value,
                                  });
                                  event.target.value === ""
                                    ? this.setState({
                                        quantityError: (
                                          <small className="text-danger">
                                            Quantity is required.
                                          </small>
                                        ),
                                      })
                                    : this.setState({ quantityError: null });
                                }}
                                placeholder="Quantity"
                                type="number"
                              />
                              {this.state.quantityError}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <ControlLabel>Deliver Before</ControlLabel>
                              <FormControl
                                name="deliver_before"
                                value={this.state.deliver_before}
                                onWheel={(e) => e.target.blur()}
                                onChange={(event) => {
                                  this.setState({
                                    deliver_before: event.target.value,
                                  });
                                  event.target.value === ""
                                    ? this.setState({
                                        deliver_beforeError: (
                                          <small className="text-danger">
                                            Deliver Before is required.
                                          </small>
                                        ),
                                      })
                                    : this.setState({
                                        deliver_beforeError: null,
                                      });
                                }}
                                placeholder="Enter Deliver Before"
                                type="number"
                              />
                              {this.state.deliver_beforeError}
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>Discount</ControlLabel>
                              <FormControl
                                name="discount"
                                value={this.state.discount}
                                onWheel={(e) => e.target.blur()}
                                onChange={(event) => {
                                  this.setState({
                                    discount: event.target.value,
                                  });
                                  event.target.value === ""
                                    ? this.setState({
                                        discountError: (
                                          <small className="text-danger">
                                            Discount is required.
                                          </small>
                                        ),
                                      })
                                    : this.setState({ discountError: null });
                                }}
                                placeholder="Enter Discount"
                                type="number"
                              />
                              {this.state.discountError}
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Package Images</ControlLabel>
                              <br></br>

                              <div className="col-md-12">
                                <div className="col-md-4 no-padding">
                                  <input
                                    style={{ display: "none" }}
                                    id="selectImage"
                                    type="file"
                                    className="form-control"
                                    name="package_image"
                                    multiple
                                    onChange={this.handleFileChange}
                                  />
                                  <Button
                                    onClick={this.upload}
                                    style={{ color: "#2B3A41" }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        this.state.package_image == ""
                                          ? "fa fa-plus"
                                          : "fa fa-pencil fa-fw"
                                      }
                                    ></i>{" "}
                                    {this.state.package_image == ""
                                      ? "Choose File"
                                      : "Change File"}
                                  </Button>
                                </div>
                              </div>
                              {this.state.packageImageError}
                            </FormGroup>
                            <FormGroup>
                              <Table>
                                <tr>
                                  {this.state.package_image_data.map(
                                    (pid, i) => (
                                      <>
                                        <td style={{ width: "30px" }}>
                                          <Radio
                                            style={{ display: "inline-block" }}
                                            number={"5" + i}
                                            option={pid}
                                            name="primaryimage"
                                            onChange={this.onChange}
                                            checked={
                                              this.state.primaryimage === pid
                                            }
                                            //  label="Web"
                                          />
                                        </td>
                                        <td>
                                          <a href={pid} target="_blank">
                                            <img
                                              src={pid}
                                              style={{
                                                height: "30px",
                                                width: "30px",
                                              }}
                                            ></img>
                                          </a>
                                        </td>
                                      </>
                                    )
                                  )}
                                </tr>
                              </Table>
                            </FormGroup>

                            <FormGroup>
                              <ControlLabel>Product Items</ControlLabel>
                              <Select
                                className="react-select info"
                                classNamePrefix="react-select"
                                placeholder="Subscription Package"
                                name="packageitem"
                                closeMenuOnSelect={false}
                                isMulti
                                value={this.state.packageitem}
                                onChange={(value) =>
                                  this.setState({
                                    packageitem: value,
                                  })
                                }
                                options={this.state.packageitemoptiondetails}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <h4 style={{ textAlign: "left", fontWeight: "bold" }}>
                            Additional Convenience Fee
                          </h4>
                          <Col md={6}>
                            <FormGroup>
                              <ControlLabel>Title</ControlLabel>
                              <FormControl
                                name="Charge_type"
                                value={this.state.charge_type}
                                onChange={(event) => {
                                  this.setState({
                                    charge_type: event.target.value,
                                  });
                                }}
                                placeholder="Title"
                                type="text"
                              />
                              {this.state.charge_typeError}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <ControlLabel>Value</ControlLabel>
                              <FormControl
                                name="Charge_value"
                                onWheel={(e) => e.target.blur()}
                                value={this.state.charge_value}
                                onChange={(event) => {
                                  this.setState({
                                    charge_value: event.target.value,
                                  });
                                }}
                                placeholder="Value "
                                type="number"
                              />
                              {this.state.charge_valueError}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      class="btn-color"
                      fill
                    >
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editsubscription;
